'use strict'
Object.defineProperty(exports, '__esModule', { value: true })
exports.lightTheme = void 0
exports.lightTheme = {
  background: {
    DEFAULT: '#FFFFFF',
    surface: {
      DEFAULT: '#F9F8F6',
      hovered: '#F5F3EF',
      secondary: '#F1EEE9',
    },
    overlay: {
      DEFAULT: '#FFFFFF',
      hovered: '#F9F8F6',
    },
    inverse: '#100E0E',
  },
  fill: {
    brand: {
      primary: {
        DEFAULT: '#0066FF',
        hovered: '#005CE5',
      },
      secondary: {
        DEFAULT: '#100E0E',
        hovered: '#000000',
      },
    },
    disabled: '#D7D2CB',
    opaque: '#18161608',
    info: {
      DEFAULT: '#0092FF',
      secondary: '#91D0FF26',
    },
    success: {
      DEFAULT: '#199E61',
      secondary: '#199E6126',
    },
    warning: {
      DEFAULT: '#E56000',
      secondary: '#E5600026',
    },
    critical: {
      DEFAULT: '#E51C00',
      secondary: '#E51C0026',
    },
    promo: {
      DEFAULT: '#8051FF',
      secondary: '#8051FF26',
    },
  },
  foreground: {
    normal: '#181616',
    subtle: '#787573',
    accent: '#0066FF',
    warning: '#E56000',
    disabled: '#787573',
    'on-fill': '#F5F3EF',
    'on-inverse': '#F5F3EF',
  },
  border: {
    normal: '#1816160F',
    strong: '#181616',
    info: '#0092FF',
    success: '#199E61',
    warning: '#E56000',
    critical: '#E51C00',
    promo: '#8051FF',
  },
  focus: {
    outline: '#0066FF',
  },
}
